import { ModalCursoEspecifico } from "./ModalCursoEspecifico";
import { ModalCursos } from "./ModalCursos";
import { General } from "./General";

export const Recomendar ={
    General:General,
    ModalCursos:ModalCursos,
    ModalCursoEspecifico:ModalCursoEspecifico
}